/* eslint-disable react-hooks/exhaustive-deps */
import { Flex, Space, Text } from '@tonic-one/react';

import CustomDateInput from '../../../components/Common/Time/CustomDateInput';
import CustomTimeInput from '../../../components/Common/Time/CustomTimeInput';
import { useEffect, useMemo } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface Range {
  startDate: Date;
  startTime: string;
  endDate: Date;
  endTime: string;
}

const TimeRange = ({
  range,
  setRange,
  withEditPermission = true,
}: {
  range: Range;
  setRange: (v: Range) => void;
  withEditPermission?: boolean;
}) => {
  const { t } = useTranslation('policy');
  const endTimeMinDateAndMaxDate = useMemo(() => {
    const subStartTime = dayjs(range.startDate).add(31, 'days');
    const maxDate = dayjs().isBefore(subStartTime) ? dayjs() : subStartTime;
    return {
      minEndDate: range.startDate,
      maxEndDate: maxDate.toDate(),
    };
  }, [range.startDate]);

  const handleStartDateChange = (value: Date) => {
    setRange({
      ...range,
      startDate: value,
    });
  };
  const handleEndDateChange = (value: Date) => {
    setRange({
      ...range,
      endDate: value,
    });
  };
  const handleStartTimeChange = (value: string) => {
    setRange({
      ...range,
      startTime: value,
    });
  };
  const handleEndTimeChange = (value: string) => {
    setRange({
      ...range,
      endTime: value,
    });
  };

  useEffect(() => {
    const daysAfterStart = dayjs(range.startDate).add(31, 'days');
    //如果结束的时间 比 开始的时间 + 31天 还要晚， 把结束的时间改成 开始的时间 + 31天
    if (daysAfterStart.isBefore(range.endDate)) {
      setRange({
        ...range,
        endDate: daysAfterStart.toDate(),
      });
    }
    //如果结束的时间 比开始的时间 还要早, 把结束的时间 改成和 开始的时间一样
    if (dayjs(range.endDate).isBefore(range.startDate)) {
      setRange({
        ...range,
        endDate: range.startDate,
      });
    }
  }, [range.startDate]);

  return (
    <Flex align="center">
      <CustomDateInput
        defaultValue={range.startDate}
        onChange={handleStartDateChange}
        maxDate={new Date()}
        disabled={!withEditPermission}
        withEditPermission={withEditPermission}
      />
      <CustomTimeInput
        onChange={handleStartTimeChange}
        value={range.startTime}
        disabled={!withEditPermission}
        withEditPermission={withEditPermission}
      />
      <Space width="12px" />
      <Text>{t('policy.modals.manualScan.scanScope.to')}:</Text>
      <Space width="8px" />
      <CustomDateInput
        defaultValue={range.endDate}
        onChange={handleEndDateChange}
        minDate={endTimeMinDateAndMaxDate.minEndDate}
        maxDate={endTimeMinDateAndMaxDate.maxEndDate}
        disabled={!withEditPermission}
        withEditPermission={withEditPermission}
      />
      <CustomTimeInput
        onChange={handleEndTimeChange}
        value={range.endTime}
        disabled={!withEditPermission}
        withEditPermission={withEditPermission}
      />
    </Flex>
  );
};

export default TimeRange;
